import { cn } from '@massilia/ui'

interface FlightCountBadgeProps {
  count: number
  disabled?: boolean
}

export function FlightCountBadge({ count, disabled = false }: FlightCountBadgeProps) {
  return (
    <span
      className={cn(
        'rounded-full px-2 py-1 text-xs',
        { 'bg-gray-100 text-gray-400': disabled || count === 0 },
        { 'bg-blue-100 text-blue-700': !disabled && count > 0 }
      )}
    >
      {count}
    </span>
  )
}
